export default "__VITE_ASSET__5b77abc0__"